export const bookingAttachments = (state) => state.attachments;
